export enum EmojiCategoryName {
  Emotions = 'Emotions',
  Nature = 'Nature',
  Food = 'Food',
  Activities = 'Activities',
  Travel = 'Travel',
  Symbols = 'Symbols',
  Objects = 'Objects',
}

export interface IEmoji {
  name: EmojiCategoryName;
  characters: string[];
}

export const Emojis: Record<EmojiCategoryName, string[]> = {
  [EmojiCategoryName.Emotions]: [
    '😀',
    '😃',
    '😄',
    '😁',
    '😆',
    '😅',
    '🤣',
    '😂',
    '🙂',
    '🙃',
    '😉',
    '😊',
    '😇',
    '😍',
    '🤩',
    '😘',
    '😗',
    '😚',
    '😙',
    '😋',
    '😛',
    '😜',
    '🤪',
    '😝',
    '🤑',
    '🤗',
    '🤭',
    '🤫',
    '🤔',
    '🤐',
    '🤨',
    '😐',
    '😑',
    '😶',
    '😏',
    '😒',
    '🙄',
    '😬',
    '🤥',
    '😌',
    '😔',
    '😪',
    '🤤',
    '😴',
    '😷',
    '🤒',
    '🤕',
    '🤢',
    '🤮',
    '🤧',
    '😵',
    '🤯',
    '🤠',
    '😎',
    '🤓',
    '🧐',
    '😕',
    '😟',
    '🙁',
    '😮',
    '😯',
    '😲',
    '😳',
    '😦',
    '😧',
    '😨',
    '😰',
    '😥',
    '😢',
    '😭',
    '😱',
    '😖',
    '😣',
    '😞',
    '😓',
    '😩',
    '😫',
    '😤',
    '😡',
    '😠',
    '🤬',
    '😈',
    '👿',
    '💀',
    '☠️',
    '💩',
    '🤡',
    '👹',
    '👺',
    '👻',
    '👽',
    '👾',
    '🤖',
    '😺',
    '😸',
    '😹',
    '😻',
    '😼',
    '😽',
    '🙀',
    '😿',
    '😾',
    '🙈',
    '🙉',
    '🙊',
    '💋',
    '💌',
    '💘',
    '💝',
    '💖',
    '💗',
    '💓',
    '💞',
    '💕',
    '💟',
    '❣️',
    '💔',
    '❤️',
    '🧡',
    '💛',
    '💚',
    '💙',
    '💜',
    '🤎',
    '🖤',
    '🤍',
    '💯',
    '💢',
    '💥',
    '💫',
    '💦',
    '💨',
    '🕳️',
    '💣',
    '💬',
    '👁️‍🗨️',
    '🗨️',
    '🗯️',
    '💭',
    '💤',
  ],
  [EmojiCategoryName.Nature]: [
    '🐵',
    '🐒',
    '🦍',
    '🐶',
    '🐕',
    '🐩',
    '🐺',
    '🦊',
    '🐱',
    '🐈',
    '🦁',
    '🐯',
    '🐅',
    '🐆',
    '🐴',
    '🐎',
    '🦄',
    '🦓',
    '🦌',
    '🐮',
    '🐂',
    '🐃',
    '🐄',
    '🐷',
    '🐖',
    '🐗',
    '🐽',
    '🐏',
    '🐑',
    '🐐',
    '🐪',
    '🐫',
    '🦒',
    '🐘',
    '🦏',
    '🐭',
    '🐁',
    '🐀',
    '🐹',
    '🐰',
    '🐇',
    '🐿️',
    '🦔',
    '🦇',
    '🐻',
    '🐨',
    '🐼',
    '🐾',
    '🦃',
    '🐔',
    '🐓',
    '🐣',
    '🐤',
    '🐥',
    '🐦',
    '🐧',
    '🕊️',
    '🦅',
    '🦆',
    '🦉',
    '🐸',
    '🐊',
    '🐢',
    '🦎',
    '🐍',
    '🐲',
    '🐉',
    '🦕',
    '🦖',
    '🐳',
    '🐋',
    '🐬',
    '🐟',
    '🐠',
    '🐡',
    '🦈',
    '🐙',
    '🐚',
    '🐌',
    '🦋',
    '🐛',
    '🐜',
    '🐝',
    '🐞',
    '🦗',
    '🕷️',
    '🕸️',
    '🦂',
    '💐',
    '🌸',
    '💮',
    '🏵️',
    '🌹',
    '🥀',
    '🌺',
    '🌻',
    '🌼',
    '🌷',
    '🌱',
    '🌲',
    '🌳',
    '🌴',
    '🌵',
    '🌾',
    '🌿',
    '☘️',
    '🍀',
    '🍁',
    '🍂',
    '🍃',
  ],
  [EmojiCategoryName.Food]: [
    '🍇',
    '🍈',
    '🍉',
    '🍊',
    '🍋',
    '🍌',
    '🍍',
    '🥭',
    '🍎',
    '🍏',
    '🍐',
    '🍑',
    '🍒',
    '🍓',
    '🥝',
    '🍅',
    '🥥',
    '🥑',
    '🍆',
    '🥔',
    '🥕',
    '🌽',
    '🌶️',
    '🥒',
    '🥬',
    '🥦',
    '🧄',
    '🧅',
    '🍄',
    '🥜',
    '🌰',
    '🍞',
    '🥐',
    '🥖',
    '🥨',
    '🥯',
    '🥞',
    '🧇',
    '🧀',
    '🍖',
    '🍗',
    '🥩',
    '🥓',
    '🍔',
    '🍟',
    '🍕',
    '🌭',
    '🥪',
    '🌮',
    '🌯',
    '🥙',
    '🧆',
    '🥚',
    '🍳',
    '🥘',
    '🍲',
    '🥣',
    '🥗',
    '🍿',
    '🧈',
    '🧂',
    '🥫',
    '🍱',
    '🍘',
    '🍙',
    '🍚',
    '🍛',
    '🍜',
    '🍝',
    '🍠',
    '🍢',
    '🍣',
    '🍤',
    '🍥',
    '🥮',
    '🍡',
    '🥟',
    '🥠',
    '🥡',
    '🦀',
    '🦞',
    '🦐',
    '🦑',
    '🦪',
    '🍦',
    '🍧',
    '🍨',
    '🍩',
    '🍪',
    '🎂',
    '🍰',
    '🧁',
    '🥧',
    '🍫',
    '🍬',
    '🍭',
    '🍮',
    '🍯',
    '🍼',
    '🥛',
    '☕',
    '🍵',
    '🍶',
    '🍾',
    '🍷',
    '🍸',
    '🍹',
    '🍺',
    '🍻',
    '🥂',
    '🥃',
    '🥤',
    '🧃',
    '🧉',
    '🧊',
    '🥢',
    '🍽️',
    '🍴',
    '🥄',
    '🔪',
    '🏺',
  ],
  [EmojiCategoryName.Travel]: [
    '🌍',
    '🌎',
    '🌏',
    '🌐',
    '🗺️',
    '🗾',
    '🧭',
    '🏔️',
    '⛰️',
    '🌋',
    '🗻',
    '🏕️',
    '🏖️',
    '🏜️',
    '🏝️',
    '🏞️',
    '🏟️',
    '🏛️',
    '🏗️',
    '🧱',
    '🏘️',
    '🏚️',
    '🏠',
    '🏡',
    '🏢',
    '🏣',
    '🏤',
    '🏥',
    '🏦',
    '🏨',
    '🏩',
    '🏪',
    '🏫',
    '🏬',
    '🏭',
    '🏯',
    '🏰',
    '💒',
    '🗼',
    '🗽',
    '⛪',
    '🕌',
    '🛕',
    '🕍',
    '⛩️',
    '🕋',
    '⛲',
    '⛺',
    '🌁',
    '🌃',
    '🏙️',
    '🌄',
    '🌅',
    '🌆',
    '🌇',
    '🌉',
    '♨️',
    '🎠',
    '🎡',
    '🎢',
    '💈',
    '🎪',
    '🚂',
    '🚃',
    '🚄',
    '🚅',
    '🚆',
    '🚇',
    '🚈',
    '🚉',
    '🚊',
    '🚝',
    '🚞',
    '🚋',
    '🚌',
    '🚍',
    '🚎',
    '🚐',
    '🚑',
    '🚒',
    '🚓',
    '🚔',
    '🚕',
    '🚖',
    '🚗',
    '🚘',
    '🚙',
    '🚚',
    '🚛',
    '🚜',
    '🏎️',
    '🏍️',
    '🛵',
    '🦽',
    '🦼',
    '🛺',
    '🚲',
    '🛴',
    '🛹',
    '🚏',
    '🛣️',
    '🛤️',
    '🛢️',
    '⛽',
    '🚨',
    '🚥',
    '🚦',
    '🛑',
    '🚧',
    '⚓',
    '⛵',
    '🛶',
    '🚤',
    '🛳️',
    '⛴️',
    '🛥️',
    '🚢',
    '✈️',
    '🛩️',
    '🛫',
    '🛬',
    '🪂',
    '💺',
    '🚁',
    '🚟',
    '🚠',
    '🚡',
    '🛰️',
    '🚀',
    '🛸',
    '🛎️',
    '🧳',
    '⌛',
    '⏳',
    '⌚',
    '⏰',
    '⏱️',
    '⏲️',
    '🕰️',
    '🕛',
    '🕧',
    '🕐',
    '🕜',
    '🕑',
    '🕝',
    '🕒',
    '🕞',
    '🕓',
    '🕟',
    '🕔',
    '🕠',
    '🕕',
    '🕡',
    '🕖',
    '🕢',
    '🕗',
    '🕣',
    '🕘',
    '🕤',
    '🕙',
    '🕥',
    '🕚',
    '🕦',
    '🌑',
    '🌒',
    '🌓',
    '🌔',
    '🌕',
    '🌖',
    '🌗',
    '🌘',
    '🌙',
    '🌚',
    '🌛',
    '🌜',
    '🌡️',
    '☀️',
    '🌝',
    '🌞',
    '🪐',
    '⭐',
    '🌟',
    '🌠',
    '🌌',
    '☁️',
    '⛅',
    '⛈️',
    '🌤️',
    '🌥️',
    '🌦️',
    '🌧️',
    '🌨️',
    '🌩️',
    '🌪️',
    '🌫️',
    '🌬️',
    '🌀',
    '🌈',
    '🌂',
    '☂️',
    '☔',
    '⛱️',
    '⚡',
    '❄️',
    '☃️',
    '⛄',
    '☄️',
    '🔥',
    '💧',
    '🌊',
  ],
  [EmojiCategoryName.Activities]: [
    '🎃',
    '🎄',
    '🎆',
    '🎇',
    '🧨',
    '✨',
    '🎈',
    '🎉',
    '🎊',
    '🎋',
    '🎍',
    '🎎',
    '🎏',
    '🎐',
    '🎑',
    '🧧',
    '🎀',
    '🎁',
    '🎗️',
    '🎟️',
    '🎫',
    '🎖️',
    '🏆',
    '🏅',
    '🥇',
    '🥈',
    '🥉',
    '⚽',
    '⚾',
    '🥎',
    '🏀',
    '🏐',
    '🏈',
    '🏉',
    '🎾',
    '🥏',
    '🎳',
    '🏏',
    '🏑',
    '🏒',
    '🥍',
    '🏓',
    '🏸',
    '🥊',
    '🥋',
    '🥅',
    '⛳',
    '⛸️',
    '🎣',
    '🤿',
    '🎽',
    '🎿',
    '🛷',
    '🥌',
    '🎯',
    '🪀',
    '🪁',
    '🎱',
    '🔮',
    '🧿',
    '🎮',
    '🕹️',
    '🎰',
    '🎲',
    '🧩',
    '🧸',
    '♠️',
    '♥️',
    '♦️',
    '♣️',
    '♟️',
    '🃏',
    '🀄',
    '🎴',
    '🎭',
    '🖼️',
    '🎨',
    '🧵',
    '🧶',
  ],
  [EmojiCategoryName.Objects]: [
    '👓',
    '🕶️',
    '🥽',
    '🥼',
    '🦺',
    '👔',
    '👕',
    '👖',
    '🧣',
    '🧤',
    '🧥',
    '🧦',
    '👗',
    '👘',
    '🥻',
    '🩱',
    '🩲',
    '🩳',
    '👙',
    '👚',
    '👛',
    '👜',
    '👝',
    '🛍️',
    '🎒',
    '👞',
    '👟',
    '🥾',
    '🥿',
    '👠',
    '👡',
    '🩰',
    '👢',
    '👑',
    '👒',
    '🎩',
    '🎓',
    '🧢',
    '⛑️',
    '📿',
    '💄',
    '💍',
    '💎',
    '🔇',
    '🔈',
    '🔉',
    '🔊',
    '📢',
    '📣',
    '📯',
    '🔔',
    '🔕',
    '🎼',
    '🎵',
    '🎶',
    '🎙️',
    '🎚️',
    '🎛️',
    '🎤',
    '🎧',
    '📻',
    '🎷',
    '🎸',
    '🎹',
    '🎺',
    '🎻',
    '🪕',
    '🥁',
    '📱',
    '📲',
    '☎️',
    '📞',
    '📟',
    '📠',
    '🔋',
    '🔌',
    '💻',
    '🖥️',
    '🖨️',
    '⌨️',
    '🖱️',
    '🖲️',
    '💽',
    '💾',
    '💿',
    '📀',
    '🧮',
    '🎥',
    '🎞️',
    '📽️',
    '🎬',
    '📺',
    '📷',
    '📸',
    '📹',
    '📼',
    '🔍',
    '🔎',
    '🕯️',
    '💡',
    '🔦',
    '🏮',
    '🪔',
    '📔',
    '📕',
    '📖',
    '📗',
    '📘',
    '📙',
    '📚',
    '📓',
    '📒',
    '📃',
    '📜',
    '📄',
    '📰',
    '🗞️',
    '📑',
    '🔖',
    '🏷️',
    '💰',
    '💴',
    '💵',
    '💶',
    '💷',
    '💸',
    '💳',
    '🧾',
    '💹',
    '💱',
    '💲',
    '✉️',
    '📧',
    '📨',
    '📩',
    '📤',
    '📥',
    '📦',
    '📫',
    '📪',
    '📬',
    '📭',
    '📮',
    '🗳️',
    '✏️',
    '✒️',
    '🖋️',
    '🖊️',
    '🖌️',
    '🖍️',
    '📝',
    '💼',
    '📁',
    '📂',
    '🗂️',
    '📅',
    '📆',
    '🗒️',
    '🗓️',
    '📇',
    '📈',
    '📉',
    '📊',
    '📋',
    '📌',
    '📍',
    '📎',
    '🖇️',
    '📏',
    '📐',
    '✂️',
    '🗃️',
    '🗄️',
    '🗑️',
    '🔒',
    '🔓',
    '🔏',
    '🔐',
    '🔑',
    '🗝️',
    '🔨',
    '🪓',
    '⛏️',
    '⚒️',
    '🛠️',
    '🗡️',
    '⚔️',
    '🔫',
    '🏹',
    '🛡️',
    '🔧',
    '🔩',
    '⚙️',
    '🗜️',
    '⚖️',
    '🦯',
    '🔗',
    '⛓️',
    '🧰',
    '🧲',
    '⚗️',
    '🧪',
    '🧫',
    '🧬',
    '🔬',
    '🔭',
    '📡',
    '💉',
    '🩸',
    '💊',
    '🩹',
    '🩺',
    '🚪',
    '🛏️',
    '🛋️',
    '🪑',
    '🚽',
    '🚿',
    '🛁',
    '🪒',
    '🧴',
    '🧷',
    '🧹',
    '🧺',
    '🧻',
    '🧼',
    '🧽',
    '🧯',
    '🛒',
    '🚬',
    '⚰️',
    '⚱️',
    '🗿',
  ],
  [EmojiCategoryName.Symbols]: [
    '🏧',
    '🚮',
    '🚰',
    '♿',
    '🚹',
    '🚺',
    '🚻',
    '🚼',
    '🚾',
    '🛂',
    '🛃',
    '🛄',
    '🛅',
    '⚠️',
    '🚸',
    '⛔',
    '🚫',
    '🚳',
    '🚭',
    '🚯',
    '🚱',
    '🚷',
    '📵',
    '🔞',
    '☢️',
    '☣️',
    '⬆️',
    '↗️',
    '➡️',
    '↘️',
    '⬇️',
    '↙️',
    '⬅️',
    '↖️',
    '↕️',
    '↔️',
    '↩️',
    '↪️',
    '⤴️',
    '⤵️',
    '🔃',
    '🔄',
    '🔙',
    '🔚',
    '🔛',
    '🔜',
    '🔝',
    '🛐',
    '⚛️',
    '🕉️',
    '✡️',
    '☸️',
    '☯️',
    '✝️',
    '☦️',
    '☪️',
    '☮️',
    '🕎',
    '🔯',
    '♈',
    '♉',
    '♊',
    '♋',
    '♌',
    '♍',
    '♎',
    '♏',
    '♐',
    '♑',
    '♒',
    '♓',
    '⛎',
    '🔀',
    '🔁',
    '🔂',
    '▶️',
    '⏩',
    '⏭️',
    '⏯️',
    '◀️',
    '⏪',
    '⏮️',
    '🔼',
    '⏫',
    '🔽',
    '⏬',
    '⏸️',
    '⏹️',
    '⏺️',
    '⏏️',
    '🎦',
    '🔅',
    '🔆',
    '📶',
    '📳',
    '📴',
    '♀️',
    '♂️',
    '⚕️',
    '♾️',
    '♻️',
    '⚜️',
    '🔱',
    '📛',
    '🔰',
    '⭕',
    '✅',
    '☑️',
    '✔️',
    '✖️',
    '❌',
    '❎',
    '➕',
    '➖',
    '➗',
    '➰',
    '➿',
    '〽️',
    '✳️',
    '✴️',
    '❇️',
    '‼️',
    '⁉️',
    '❓',
    '❔',
    '❕',
    '❗',
    '〰️',
    '©️',
    '®️',
    '™️',
    '#️⃣',
    '*️⃣',
    '0️⃣',
    '1️⃣',
    '2️⃣',
    '3️⃣',
    '4️⃣',
    '5️⃣',
    '6️⃣',
    '7️⃣',
    '8️⃣',
    '9️⃣',
    '🔟',
    '🔠',
    '🔡',
    '🔢',
    '🔣',
    '🔤',
    '🅰️',
    '🆎',
    '🅱️',
    '🆑',
    '🆒',
    '🆓',
    'ℹ️',
    '🆔',
    'Ⓜ️',
    '🆕',
    '🆖',
    '🅾️',
    '🆗',
    '🅿️',
    '🆘',
    '🆙',
    '🆚',
    '🈁',
    '🈂️',
    '🈷️',
    '🈶',
    '🈯',
    '🉐',
    '🈹',
    '🈚',
    '🈲',
    '🉑',
    '🈸',
    '🈴',
    '🈳',
    '㊗️',
    '㊙️',
    '🈺',
    '🈵',
    '🔴',
    '🟠',
    '🟡',
    '🟢',
    '🔵',
    '🟣',
    '🟤',
    '⚫',
    '⚪',
    '🟥',
    '🟧',
    '🟨',
    '🟩',
    '🟦',
    '🟪',
    '🟫',
    '⬛',
    '⬜',
    '◼️',
    '◻️',
    '◾',
    '◽',
    '▪️',
    '▫️',
    '🔶',
    '🔷',
    '🔸',
    '🔹',
    '🔺',
    '🔻',
    '💠',
    '🔘',
    '🔳',
    '🔲',
  ],
};
